module.exports = __webpack_public_path__ + "static/media/close_icon.5138ed2f.svg";